import { useEffect } from "react";
import FillFormSection from "./fill-form-section";
import { useLocation } from "react-router-dom";
import { paymentCallback } from "../../Services/api-service";

function PhuBaoAnGiaProduct({ objectDto, setObjectDto }) {
  const location = useLocation();
  const getQueryParam = (param) => {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get(param); 
  };
  useEffect(() => {
    const queryData = getQueryParam("data"); 
    if (queryData) {
        paymentCallback(queryData, setObjectDto);
    }
  }, []); 

  return (
    <>
      <FillFormSection
        objectDto={objectDto}
        setObjectDto={setObjectDto}
      />
    </>
  );
}

export default PhuBaoAnGiaProduct;
